var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M10.59 1.39335e-08L6 4.32659L1.41 4.15204e-07L-2.47757e-07 1.33198L6 7L12 1.33198L10.59 1.39335e-08Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }